import {action, makeObservable, observable, runInAction} from 'mobx';
import {mainState} from '../../AppMainState';
import {showLoaderAsync} from '../../helpers/loaders';
import {SocialLoginState} from '../../components/social-login/SocialLoginState';
import {showAlert, showWarning} from '../../helpers/alerts';
import {api} from '../../ApiFacade';
import {redirectTo} from '../../routing/browserHistory';

export const demoEmail = 'demo@muscula.com';

export class LoginState extends SocialLoginState {
    @observable
    email?: string;
    @observable
    password?: string;
    @observable
    invalidData: boolean = false;

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        if (this.isDemoMode) {
            this.email = demoEmail;
            this.password = demoEmail;
            this.signIn();
        }

        makeObservable(this);
    }

    get isDemoMode(): boolean {
        return window.location.hash === '#demo';
    }

    @action
    setEmail(v: string) {
        this.email = v;
    }

    @action
    setPassword(v: string) {
        this.password = v;
    }

    @action
    signIn() {
        if (!this.email || !this.password) {
            this.invalidData = true;
            return;
        }

        showLoaderAsync(this.userAuthApi.apiUserAuthLoginPost({
            loginLocalRequest: {
                email: this.email,
                password: this.password,
            }
        })).then(res => {
            mainState.loadBaseAppInformation();
            // @ts-ignore
            if (typeof window.plausible === 'function') {
                if (this.isDemoMode) {
                    // @ts-ignore
                    plausible('LoginDemo');
                } else {
                    // @ts-ignore
                    plausible('Login');
                }
            }

        }).catch(err => {
            console.error('Login error', err);
            if (err && err.status && err.status === 401) {
                showWarning('Invalid login or password', 'Please try again');
            }
            runInAction(() => {
                this.invalidData = true;
            });
        });
    }

    resetPassword() {
        if (!this.email || this.email.length < 3) {
            showWarning('No email provided', 'Please enter valid email to reset your password');
            return;
        }

        api().userAuth.userAuthSendpasswordtokenPost({
            email: this.email,
        }).then(res => {
            showAlert('Email sent', 'Check your inbox and spam folder for reset password email', 'success');
            redirectTo('/');
        }).catch(err => {
            console.log('Password reset response', err);
            showWarning('Email not found', 'Email was not found, please try another one. ' +
                'If you are using username from old, legacy Muscula App it will not work here. Just create new user then.');
        });
    }
}
